/* eslint-disable */
/* istanbul ignore file */

// @generated by Peggy 5.0.3.
//
// https://peggyjs.org/

class peg$SyntaxError extends SyntaxError {
    constructor(message, expected, found, location) {
        super(message);
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
    }

    format(sources) {
        let str = "Error: " + this.message;
        if (this.location) {
            let src = null;
            const st = sources.find((s) => s.source === this.location.source);
            if (st) {
                src = st.text.split(/\r\n|\n|\r/g);
            }
            const s = this.location.start;
            const offset_s =
                this.location.source && typeof this.location.source.offset === "function"
                    ? this.location.source.offset(s)
                    : s;
            const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
            if (src) {
                const e = this.location.end;
                const filler = "".padEnd(offset_s.line.toString().length, " ");
                const line = src[s.line - 1];
                const last = s.line === e.line ? e.column : line.length + 1;
                const hatLen = last - s.column || 1;
                str +=
                    "\n --> " +
                    loc +
                    "\n" +
                    filler +
                    " |\n" +
                    offset_s.line +
                    " | " +
                    line +
                    "\n" +
                    filler +
                    " | " +
                    "".padEnd(s.column - 1, " ") +
                    "".padEnd(hatLen, "^");
            } else {
                str += "\n at " + loc;
            }
        }
        return str;
    }

    static buildMessage(expected, found) {
        function hex(ch) {
            return ch.codePointAt(0).toString(16).toUpperCase();
        }

        const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode")
            ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu")
            : null;
        function unicodeEscape(s) {
            if (nonPrintable) {
                return s.replace(nonPrintable, (ch) => "\\u{" + hex(ch) + "}");
            }
            return s;
        }

        function literalEscape(s) {
            return unicodeEscape(
                s
                    .replace(/\\/g, "\\\\")
                    .replace(/"/g, '\\"')
                    .replace(/\0/g, "\\0")
                    .replace(/\t/g, "\\t")
                    .replace(/\n/g, "\\n")
                    .replace(/\r/g, "\\r")
                    .replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch))
                    .replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)),
            );
        }

        function classEscape(s) {
            return unicodeEscape(
                s
                    .replace(/\\/g, "\\\\")
                    .replace(/\]/g, "\\]")
                    .replace(/\^/g, "\\^")
                    .replace(/-/g, "\\-")
                    .replace(/\0/g, "\\0")
                    .replace(/\t/g, "\\t")
                    .replace(/\n/g, "\\n")
                    .replace(/\r/g, "\\r")
                    .replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch))
                    .replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)),
            );
        }

        const DESCRIBE_EXPECTATION_FNS = {
            literal(expectation) {
                return '"' + literalEscape(expectation.text) + '"';
            },

            class(expectation) {
                const escapedParts = expectation.parts.map((part) =>
                    Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part),
                );

                return (
                    "[" +
                    (expectation.inverted ? "^" : "") +
                    escapedParts.join("") +
                    "]" +
                    (expectation.unicode ? "u" : "")
                );
            },

            any() {
                return "any character";
            },

            end() {
                return "end of input";
            },

            other(expectation) {
                return expectation.description;
            },
        };

        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }

        function describeExpected(expected) {
            const descriptions = expected.map(describeExpectation);
            descriptions.sort();

            if (descriptions.length > 0) {
                let j = 1;
                for (let i = 1; i < descriptions.length; i++) {
                    if (descriptions[i - 1] !== descriptions[i]) {
                        descriptions[j] = descriptions[i];
                        j++;
                    }
                }
                descriptions.length = j;
            }

            switch (descriptions.length) {
                case 1:
                    return descriptions[0];

                case 2:
                    return descriptions[0] + " or " + descriptions[1];

                default:
                    return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
            }
        }

        function describeFound(found) {
            return found ? '"' + literalEscape(found) + '"' : "end of input";
        }

        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    }
}

function peg$parse(input, options) {
    options = options !== undefined ? options : {};

    const peg$FAILED = {};
    const peg$source = options.grammarSource;

    const peg$startRuleFunctions = {
        batch: peg$parsebatch,
    };
    let peg$startRuleFunction = peg$parsebatch;

    const peg$c0 = "\r";
    const peg$c1 = "\n";
    const peg$c2 = "--changesetresponse";
    const peg$c3 = "--batchresponse";
    const peg$c4 = "Content-ID: ";
    const peg$c5 = "[";
    const peg$c6 = "{";
    const peg$c7 = "]";
    const peg$c8 = "}";
    const peg$c9 = ":";
    const peg$c10 = ",";
    const peg$c11 = "false";
    const peg$c12 = "null";
    const peg$c13 = "true";
    const peg$c14 = ".";
    const peg$c15 = "-";
    const peg$c16 = "0";
    const peg$c17 = "b";
    const peg$c18 = "f";
    const peg$c19 = "n";
    const peg$c20 = "r";
    const peg$c21 = "t";
    const peg$c22 = "u";
    const peg$c23 = "\\";
    const peg$c24 = '"';

    const peg$r0 = /^[\-_a-zA-Z0-9]/;
    const peg$r1 = /^[^\n\r]/;
    const peg$r2 = /^[0-9]/;
    const peg$r3 = /^[ \t\n\r]/;
    const peg$r4 = /^[1-9]/;
    const peg$r5 = /^[eE]/;
    const peg$r6 = /^[+\-]/;
    const peg$r7 = /^["\/\\]/;
    const peg$r8 = /^[^\0-\x1F"\\]/;
    const peg$r9 = /^[0-9a-f]/i;

    const peg$e0 = peg$literalExpectation("\r", false);
    const peg$e1 = peg$literalExpectation("\n", false);
    const peg$e2 = peg$literalExpectation("--changesetresponse", false);
    const peg$e3 = peg$classExpectation(["-", "_", ["a", "z"], ["A", "Z"], ["0", "9"]], false, false, false);
    const peg$e4 = peg$classExpectation(["\n", "\r"], true, false, false);
    const peg$e5 = peg$literalExpectation("--batchresponse", false);
    const peg$e6 = peg$literalExpectation("Content-ID: ", false);
    const peg$e7 = peg$classExpectation([["0", "9"]], false, false, false);
    const peg$e8 = peg$literalExpectation("[", false);
    const peg$e9 = peg$literalExpectation("{", false);
    const peg$e10 = peg$literalExpectation("]", false);
    const peg$e11 = peg$literalExpectation("}", false);
    const peg$e12 = peg$literalExpectation(":", false);
    const peg$e13 = peg$literalExpectation(",", false);
    const peg$e14 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false, false);
    const peg$e15 = peg$literalExpectation("false", false);
    const peg$e16 = peg$literalExpectation("null", false);
    const peg$e17 = peg$literalExpectation("true", false);
    const peg$e18 = peg$otherExpectation("number");
    const peg$e19 = peg$literalExpectation(".", false);
    const peg$e20 = peg$classExpectation([["1", "9"]], false, false, false);
    const peg$e21 = peg$classExpectation(["e", "E"], false, false, false);
    const peg$e22 = peg$classExpectation(["+", "-"], false, false, false);
    const peg$e23 = peg$literalExpectation("-", false);
    const peg$e24 = peg$literalExpectation("0", false);
    const peg$e25 = peg$otherExpectation("string");
    const peg$e26 = peg$classExpectation(['"', "/", "\\"], false, false, false);
    const peg$e27 = peg$literalExpectation("b", false);
    const peg$e28 = peg$literalExpectation("f", false);
    const peg$e29 = peg$literalExpectation("n", false);
    const peg$e30 = peg$literalExpectation("r", false);
    const peg$e31 = peg$literalExpectation("t", false);
    const peg$e32 = peg$literalExpectation("u", false);
    const peg$e33 = peg$literalExpectation("\\", false);
    const peg$e34 = peg$literalExpectation('"', false);
    const peg$e35 = peg$classExpectation([["\0", "\x1F"], '"', "\\"], true, false, false);
    const peg$e36 = peg$classExpectation(
        [
            ["0", "9"],
            ["a", "f"],
        ],
        false,
        true,
        false,
    );

    function peg$f0(batches) {
        return batches;
    }
    function peg$f1(batch, changesets) {
        return changesets.filter((c) => c.c || c.result).map((c) => ({ contentId: c.contentId, result: c.result }));
    }
    function peg$f2(c, httpHeader, json) {
        return { c: c, contentId: httpHeader, result: json };
    }
    function peg$f3(c) {
        return c.join("");
    }
    function peg$f4(before, id, after) {
        return id && id[1].join("");
    }
    function peg$f5(value) {
        return value;
    }
    function peg$f6() {
        return false;
    }
    function peg$f7() {
        return null;
    }
    function peg$f8() {
        return true;
    }
    function peg$f9(head, m) {
        return m;
    }
    function peg$f10(head, tail) {
        var result = {};

        [head].concat(tail).forEach(function (element) {
            result[element.name] = element.value;
        });

        return result;
    }
    function peg$f11(members) {
        return members !== null ? members : {};
    }
    function peg$f12(name, value) {
        return { name: name, value: value };
    }
    function peg$f13(head, v) {
        return v;
    }
    function peg$f14(head, tail) {
        return [head].concat(tail);
    }
    function peg$f15(values) {
        return values !== null ? values : [];
    }
    function peg$f16() {
        return parseFloat(text());
    }
    function peg$f17(chars) {
        return chars.join("");
    }
    function peg$f18() {
        return "\b";
    }
    function peg$f19() {
        return "\f";
    }
    function peg$f20() {
        return "\n";
    }
    function peg$f21() {
        return "\r";
    }
    function peg$f22() {
        return "\t";
    }
    function peg$f23(digits) {
        return String.fromCharCode(parseInt(digits, 16));
    }
    function peg$f24(sequence) {
        return sequence;
    }
    let peg$currPos = options.peg$currPos | 0;
    let peg$savedPos = peg$currPos;
    const peg$posDetailsCache = [{ line: 1, column: 1 }];
    let peg$maxFailPos = peg$currPos;
    let peg$maxFailExpected = options.peg$maxFailExpected || [];
    let peg$silentFails = options.peg$silentFails | 0;

    let peg$result;

    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
        }

        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }

    function offset() {
        return peg$savedPos;
    }

    function range() {
        return {
            source: peg$source,
            start: peg$savedPos,
            end: peg$currPos,
        };
    }

    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);

        throw peg$buildStructuredError(
            [peg$otherExpectation(description)],
            input.substring(peg$savedPos, peg$currPos),
            location,
        );
    }

    function error(message, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);

        throw peg$buildSimpleError(message, location);
    }

    function peg$getUnicode(pos = peg$currPos) {
        const cp = input.codePointAt(pos);
        if (cp === undefined) {
            return "";
        }
        return String.fromCodePoint(cp);
    }

    function peg$literalExpectation(text, ignoreCase) {
        return { type: "literal", text, ignoreCase };
    }

    function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return { type: "class", parts, inverted, ignoreCase, unicode };
    }

    function peg$anyExpectation() {
        return { type: "any" };
    }

    function peg$endExpectation() {
        return { type: "end" };
    }

    function peg$otherExpectation(description) {
        return { type: "other", description };
    }

    function peg$computePosDetails(pos) {
        let details = peg$posDetailsCache[pos];
        let p;

        if (details) {
            return details;
        } else {
            if (pos >= peg$posDetailsCache.length) {
                p = peg$posDetailsCache.length - 1;
            } else {
                p = pos;
                while (!peg$posDetailsCache[--p]) {}
            }

            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column,
            };

            while (p < pos) {
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else {
                    details.column++;
                }

                p++;
            }

            peg$posDetailsCache[pos] = details;

            return details;
        }
    }

    function peg$computeLocation(startPos, endPos, offset) {
        const startPosDetails = peg$computePosDetails(startPos);
        const endPosDetails = peg$computePosDetails(endPos);

        const res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column,
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column,
            },
        };
        if (offset && peg$source && typeof peg$source.offset === "function") {
            res.start = peg$source.offset(res.start);
            res.end = peg$source.offset(res.end);
        }
        return res;
    }

    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) {
            return;
        }

        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }

        peg$maxFailExpected.push(expected);
    }

    function peg$buildSimpleError(message, location) {
        return new peg$SyntaxError(message, null, null, location);
    }

    function peg$buildStructuredError(expected, found, location) {
        return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }

    function peg$parsebatch() {
        let s0, s1, s2, s3, s4, s5;

        s0 = peg$currPos;
        s1 = peg$parseoneBatch();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsechangesetDelimiter();
            if (s2 === peg$FAILED) {
                s2 = null;
            }
            s3 = peg$parsews();
            s4 = peg$parsebatchDelimiter();
            if (s4 === peg$FAILED) {
                s4 = null;
            }
            s5 = peg$parsews();
            peg$savedPos = s0;
            s0 = peg$f0(s1);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parseoneBatch() {
        let s0, s1, s2, s3, s4, s5, s6;

        s0 = peg$currPos;
        s1 = peg$parsebatchHeader();
        if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 13) {
                s2 = peg$c0;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e0);
                }
            }
            if (s2 === peg$FAILED) {
                s2 = null;
            }
            if (input.charCodeAt(peg$currPos) === 10) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e1);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parseoneChangeset();
                if (s5 !== peg$FAILED) {
                    while (s5 !== peg$FAILED) {
                        s4.push(s5);
                        s5 = peg$parseoneChangeset();
                    }
                } else {
                    s4 = peg$FAILED;
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parsechangesetDelimiter();
                    if (s5 === peg$FAILED) {
                        s5 = null;
                    }
                    s6 = peg$parsews();
                    peg$savedPos = s0;
                    s0 = peg$f1(s1, s4);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parseoneChangeset() {
        let s0, s1, s2, s3, s4, s5, s6, s7;

        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$parsechangesetHeader();
        if (s2 === peg$FAILED) {
            s2 = null;
        }
        if (input.charCodeAt(peg$currPos) === 13) {
            s3 = peg$c0;
            peg$currPos++;
        } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e0);
            }
        }
        if (s3 === peg$FAILED) {
            s3 = null;
        }
        if (input.charCodeAt(peg$currPos) === 10) {
            s4 = peg$c1;
            peg$currPos++;
        } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e1);
            }
        }
        if (s4 !== peg$FAILED) {
            s5 = peg$parsehttpHeader();
            if (s5 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 13) {
                    s6 = peg$c0;
                    peg$currPos++;
                } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e0);
                    }
                }
                if (s6 === peg$FAILED) {
                    s6 = null;
                }
                if (input.charCodeAt(peg$currPos) === 10) {
                    s7 = peg$c1;
                    peg$currPos++;
                } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e1);
                    }
                }
                if (s7 !== peg$FAILED) {
                    s2 = [s2, s3, s4, s5, s6, s7];
                    s1 = s2;
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 === peg$FAILED) {
            s1 = null;
        }
        s2 = peg$parsehttpHeader();
        if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 13) {
                s3 = peg$c0;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e0);
                }
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            if (input.charCodeAt(peg$currPos) === 10) {
                s4 = peg$c1;
                peg$currPos++;
            } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e1);
                }
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parseJSON_text();
                if (s5 === peg$FAILED) {
                    s5 = null;
                }
                peg$savedPos = s0;
                s0 = peg$f2(s1, s2, s5);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsechangesetHeader() {
        let s0, s1, s2, s3, s4;

        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.substr(peg$currPos, 19) === peg$c2) {
            s2 = peg$c2;
            peg$currPos += 19;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e2);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = [];
            s4 = input.charAt(peg$currPos);
            if (peg$r0.test(s4)) {
                peg$currPos++;
            } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e3);
                }
            }
            if (s4 !== peg$FAILED) {
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = input.charAt(peg$currPos);
                    if (peg$r0.test(s4)) {
                        peg$currPos++;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e3);
                        }
                    }
                }
            } else {
                s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f3(s1);
        }
        s0 = s1;

        return s0;
    }

    function peg$parsechangesetDelimiter() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        if (input.substr(peg$currPos, 19) === peg$c2) {
            s1 = peg$c2;
            peg$currPos += 19;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e2);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = input.charAt(peg$currPos);
            if (peg$r0.test(s3)) {
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e3);
                }
            }
            if (s3 !== peg$FAILED) {
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = input.charAt(peg$currPos);
                    if (peg$r0.test(s3)) {
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e3);
                        }
                    }
                }
            } else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s1 = [s1, s2];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsebatchHeader() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8;

        s0 = peg$currPos;
        s1 = peg$parsebatchDelimiter();
        if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 13) {
                s2 = peg$c0;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e0);
                }
            }
            if (s2 === peg$FAILED) {
                s2 = null;
            }
            if (input.charCodeAt(peg$currPos) === 10) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e1);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$currPos;
                s6 = [];
                s7 = input.charAt(peg$currPos);
                if (peg$r1.test(s7)) {
                    peg$currPos++;
                } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                        s6.push(s7);
                        s7 = input.charAt(peg$currPos);
                        if (peg$r1.test(s7)) {
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e4);
                            }
                        }
                    }
                } else {
                    s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 13) {
                        s7 = peg$c0;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e0);
                        }
                    }
                    if (s7 === peg$FAILED) {
                        s7 = null;
                    }
                    if (input.charCodeAt(peg$currPos) === 10) {
                        s8 = peg$c1;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e1);
                        }
                    }
                    if (s8 !== peg$FAILED) {
                        s6 = [s6, s7, s8];
                        s5 = s6;
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                    while (s5 !== peg$FAILED) {
                        s4.push(s5);
                        s5 = peg$currPos;
                        s6 = [];
                        s7 = input.charAt(peg$currPos);
                        if (peg$r1.test(s7)) {
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e4);
                            }
                        }
                        if (s7 !== peg$FAILED) {
                            while (s7 !== peg$FAILED) {
                                s6.push(s7);
                                s7 = input.charAt(peg$currPos);
                                if (peg$r1.test(s7)) {
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e4);
                                    }
                                }
                            }
                        } else {
                            s6 = peg$FAILED;
                        }
                        if (s6 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 13) {
                                s7 = peg$c0;
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e0);
                                }
                            }
                            if (s7 === peg$FAILED) {
                                s7 = null;
                            }
                            if (input.charCodeAt(peg$currPos) === 10) {
                                s8 = peg$c1;
                                peg$currPos++;
                            } else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e1);
                                }
                            }
                            if (s8 !== peg$FAILED) {
                                s6 = [s6, s7, s8];
                                s5 = s6;
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    }
                } else {
                    s4 = peg$FAILED;
                }
                if (s4 !== peg$FAILED) {
                    s1 = [s1, s2, s3, s4];
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsebatchDelimiter() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        if (input.substr(peg$currPos, 15) === peg$c3) {
            s1 = peg$c3;
            peg$currPos += 15;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e5);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = input.charAt(peg$currPos);
            if (peg$r0.test(s3)) {
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e3);
                }
            }
            if (s3 !== peg$FAILED) {
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = input.charAt(peg$currPos);
                    if (peg$r0.test(s3)) {
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e3);
                        }
                    }
                }
            } else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s1 = [s1, s2];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsehttpHeader() {
        let s0, s1, s2, s3, s4, s5, s6, s7;

        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r1.test(s3)) {
            peg$currPos++;
        } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e4);
            }
        }
        if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = input.charAt(peg$currPos);
                if (peg$r1.test(s3)) {
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
            }
        } else {
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 13) {
                s3 = peg$c0;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e0);
                }
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            if (input.charCodeAt(peg$currPos) === 10) {
                s4 = peg$c1;
                peg$currPos++;
            } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e1);
                }
            }
            if (s4 !== peg$FAILED) {
                s2 = [s2, s3, s4];
                s1 = s2;
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            if (input.substr(peg$currPos, 12) === peg$c4) {
                s3 = peg$c4;
                peg$currPos += 12;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e6);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = input.charAt(peg$currPos);
                if (peg$r2.test(s5)) {
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e7);
                    }
                }
                if (s5 !== peg$FAILED) {
                    while (s5 !== peg$FAILED) {
                        s4.push(s5);
                        s5 = input.charAt(peg$currPos);
                        if (peg$r2.test(s5)) {
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e7);
                            }
                        }
                    }
                } else {
                    s4 = peg$FAILED;
                }
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 13) {
                        s5 = peg$c0;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e0);
                        }
                    }
                    if (s5 === peg$FAILED) {
                        s5 = null;
                    }
                    if (input.charCodeAt(peg$currPos) === 10) {
                        s6 = peg$c1;
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e1);
                        }
                    }
                    if (s6 !== peg$FAILED) {
                        s3 = [s3, s4, s5, s6];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 === peg$FAILED) {
                s2 = null;
            }
            s3 = [];
            s4 = peg$currPos;
            s5 = [];
            s6 = input.charAt(peg$currPos);
            if (peg$r1.test(s6)) {
                peg$currPos++;
            } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e4);
                }
            }
            if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    s6 = input.charAt(peg$currPos);
                    if (peg$r1.test(s6)) {
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e4);
                        }
                    }
                }
            } else {
                s5 = peg$FAILED;
            }
            if (s5 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 13) {
                    s6 = peg$c0;
                    peg$currPos++;
                } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e0);
                    }
                }
                if (s6 === peg$FAILED) {
                    s6 = null;
                }
                if (input.charCodeAt(peg$currPos) === 10) {
                    s7 = peg$c1;
                    peg$currPos++;
                } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e1);
                    }
                }
                if (s7 !== peg$FAILED) {
                    s5 = [s5, s6, s7];
                    s4 = s5;
                } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                }
            } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
            }
            while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                s5 = [];
                s6 = input.charAt(peg$currPos);
                if (peg$r1.test(s6)) {
                    peg$currPos++;
                } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s6 !== peg$FAILED) {
                    while (s6 !== peg$FAILED) {
                        s5.push(s6);
                        s6 = input.charAt(peg$currPos);
                        if (peg$r1.test(s6)) {
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e4);
                            }
                        }
                    }
                } else {
                    s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 13) {
                        s6 = peg$c0;
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e0);
                        }
                    }
                    if (s6 === peg$FAILED) {
                        s6 = null;
                    }
                    if (input.charCodeAt(peg$currPos) === 10) {
                        s7 = peg$c1;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e1);
                        }
                    }
                    if (s7 !== peg$FAILED) {
                        s5 = [s5, s6, s7];
                        s4 = s5;
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f4(s1, s2, s3);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parseJSON_text() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsews();
        s2 = peg$parsevalue();
        if (s2 !== peg$FAILED) {
            s3 = peg$parsews();
            peg$savedPos = s0;
            s0 = peg$f5(s2);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsebegin_array() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsews();
        if (input.charCodeAt(peg$currPos) === 91) {
            s2 = peg$c5;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e8);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsews();
            s1 = [s1, s2, s3];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsebegin_object() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsews();
        if (input.charCodeAt(peg$currPos) === 123) {
            s2 = peg$c6;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e9);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsews();
            s1 = [s1, s2, s3];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parseend_array() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsews();
        if (input.charCodeAt(peg$currPos) === 93) {
            s2 = peg$c7;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e10);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsews();
            s1 = [s1, s2, s3];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parseend_object() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsews();
        if (input.charCodeAt(peg$currPos) === 125) {
            s2 = peg$c8;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e11);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsews();
            s1 = [s1, s2, s3];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsename_separator() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsews();
        if (input.charCodeAt(peg$currPos) === 58) {
            s2 = peg$c9;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e12);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsews();
            s1 = [s1, s2, s3];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsevalue_separator() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsews();
        if (input.charCodeAt(peg$currPos) === 44) {
            s2 = peg$c10;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e13);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsews();
            s1 = [s1, s2, s3];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsews() {
        let s0, s1;

        peg$silentFails++;
        s0 = [];
        s1 = input.charAt(peg$currPos);
        if (peg$r3.test(s1)) {
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e14);
            }
        }
        while (s1 !== peg$FAILED) {
            s0.push(s1);
            s1 = input.charAt(peg$currPos);
            if (peg$r3.test(s1)) {
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e14);
                }
            }
        }
        peg$silentFails--;

        return s0;
    }

    function peg$parsevalue() {
        let s0;

        s0 = peg$parsefalse();
        if (s0 === peg$FAILED) {
            s0 = peg$parsenull();
            if (s0 === peg$FAILED) {
                s0 = peg$parsetrue();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseobject();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parsearray();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parsenumber();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parsestring();
                            }
                        }
                    }
                }
            }
        }

        return s0;
    }

    function peg$parsefalse() {
        let s0, s1;

        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c11) {
            s1 = peg$c11;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e15);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f6();
        }
        s0 = s1;

        return s0;
    }

    function peg$parsenull() {
        let s0, s1;

        s0 = peg$currPos;
        if (input.substr(peg$currPos, 4) === peg$c12) {
            s1 = peg$c12;
            peg$currPos += 4;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e16);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f7();
        }
        s0 = s1;

        return s0;
    }

    function peg$parsetrue() {
        let s0, s1;

        s0 = peg$currPos;
        if (input.substr(peg$currPos, 4) === peg$c13) {
            s1 = peg$c13;
            peg$currPos += 4;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e17);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f8();
        }
        s0 = s1;

        return s0;
    }

    function peg$parseobject() {
        let s0, s1, s2, s3, s4, s5, s6, s7;

        s0 = peg$currPos;
        s1 = peg$parsebegin_object();
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsemember();
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$currPos;
                s6 = peg$parsevalue_separator();
                if (s6 !== peg$FAILED) {
                    s7 = peg$parsemember();
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s5;
                        s5 = peg$f9(s3, s7);
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                }
                while (s5 !== peg$FAILED) {
                    s4.push(s5);
                    s5 = peg$currPos;
                    s6 = peg$parsevalue_separator();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parsemember();
                        if (s7 !== peg$FAILED) {
                            peg$savedPos = s5;
                            s5 = peg$f9(s3, s7);
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                }
                peg$savedPos = s2;
                s2 = peg$f10(s3, s4);
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 === peg$FAILED) {
                s2 = null;
            }
            s3 = peg$parseend_object();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f11(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsemember() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsestring();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsename_separator();
            if (s2 !== peg$FAILED) {
                s3 = peg$parsevalue();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f12(s1, s3);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsearray() {
        let s0, s1, s2, s3, s4, s5, s6, s7;

        s0 = peg$currPos;
        s1 = peg$parsebegin_array();
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsevalue();
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$currPos;
                s6 = peg$parsevalue_separator();
                if (s6 !== peg$FAILED) {
                    s7 = peg$parsevalue();
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s5;
                        s5 = peg$f13(s3, s7);
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                }
                while (s5 !== peg$FAILED) {
                    s4.push(s5);
                    s5 = peg$currPos;
                    s6 = peg$parsevalue_separator();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parsevalue();
                        if (s7 !== peg$FAILED) {
                            peg$savedPos = s5;
                            s5 = peg$f13(s3, s7);
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                }
                peg$savedPos = s2;
                s2 = peg$f14(s3, s4);
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 === peg$FAILED) {
                s2 = null;
            }
            s3 = peg$parseend_array();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f15(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsenumber() {
        let s0, s1, s2, s3, s4;

        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseminus();
        if (s1 === peg$FAILED) {
            s1 = null;
        }
        s2 = peg$parseint();
        if (s2 !== peg$FAILED) {
            s3 = peg$parsefrac();
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            s4 = peg$parseexp();
            if (s4 === peg$FAILED) {
                s4 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f16();
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e18);
            }
        }

        return s0;
    }

    function peg$parsedecimal_point() {
        let s0;

        if (input.charCodeAt(peg$currPos) === 46) {
            s0 = peg$c14;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e19);
            }
        }

        return s0;
    }

    function peg$parsedigit1_9() {
        let s0;

        s0 = input.charAt(peg$currPos);
        if (peg$r4.test(s0)) {
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e20);
            }
        }

        return s0;
    }

    function peg$parsee() {
        let s0;

        s0 = input.charAt(peg$currPos);
        if (peg$r5.test(s0)) {
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e21);
            }
        }

        return s0;
    }

    function peg$parseexp() {
        let s0, s1, s2, s3, s4;

        s0 = peg$currPos;
        s1 = peg$parsee();
        if (s1 !== peg$FAILED) {
            s2 = input.charAt(peg$currPos);
            if (peg$r6.test(s2)) {
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e22);
                }
            }
            if (s2 === peg$FAILED) {
                s2 = null;
            }
            s3 = [];
            s4 = peg$parseDIGIT();
            if (s4 !== peg$FAILED) {
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parseDIGIT();
                }
            } else {
                s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
                s1 = [s1, s2, s3];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parsefrac() {
        let s0, s1, s2, s3;

        s0 = peg$currPos;
        s1 = peg$parsedecimal_point();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseDIGIT();
            if (s3 !== peg$FAILED) {
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parseDIGIT();
                }
            } else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s1 = [s1, s2];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }

        return s0;
    }

    function peg$parseint() {
        let s0, s1, s2, s3;

        s0 = peg$parsezero();
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigit1_9();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseDIGIT();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parseDIGIT();
                }
                s1 = [s1, s2];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }

        return s0;
    }

    function peg$parseminus() {
        let s0;

        if (input.charCodeAt(peg$currPos) === 45) {
            s0 = peg$c15;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e23);
            }
        }

        return s0;
    }

    function peg$parsezero() {
        let s0;

        if (input.charCodeAt(peg$currPos) === 48) {
            s0 = peg$c16;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e24);
            }
        }

        return s0;
    }

    function peg$parsestring() {
        let s0, s1, s2, s3;

        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsequotation_mark();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsechar();
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsechar();
            }
            s3 = peg$parsequotation_mark();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f17(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e25);
            }
        }

        return s0;
    }

    function peg$parsechar() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

        s0 = peg$parseunescaped();
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseescape();
            if (s1 !== peg$FAILED) {
                s2 = input.charAt(peg$currPos);
                if (peg$r7.test(s2)) {
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e26);
                    }
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 98) {
                        s3 = peg$c17;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e27);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s2;
                        s3 = peg$f18();
                    }
                    s2 = s3;
                    if (s2 === peg$FAILED) {
                        s2 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 102) {
                            s3 = peg$c18;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e28);
                            }
                        }
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s2;
                            s3 = peg$f19();
                        }
                        s2 = s3;
                        if (s2 === peg$FAILED) {
                            s2 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 110) {
                                s3 = peg$c19;
                                peg$currPos++;
                            } else {
                                s3 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e29);
                                }
                            }
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s2;
                                s3 = peg$f20();
                            }
                            s2 = s3;
                            if (s2 === peg$FAILED) {
                                s2 = peg$currPos;
                                if (input.charCodeAt(peg$currPos) === 114) {
                                    s3 = peg$c20;
                                    peg$currPos++;
                                } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e30);
                                    }
                                }
                                if (s3 !== peg$FAILED) {
                                    peg$savedPos = s2;
                                    s3 = peg$f21();
                                }
                                s2 = s3;
                                if (s2 === peg$FAILED) {
                                    s2 = peg$currPos;
                                    if (input.charCodeAt(peg$currPos) === 116) {
                                        s3 = peg$c21;
                                        peg$currPos++;
                                    } else {
                                        s3 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$e31);
                                        }
                                    }
                                    if (s3 !== peg$FAILED) {
                                        peg$savedPos = s2;
                                        s3 = peg$f22();
                                    }
                                    s2 = s3;
                                    if (s2 === peg$FAILED) {
                                        s2 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 117) {
                                            s3 = peg$c22;
                                            peg$currPos++;
                                        } else {
                                            s3 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$e32);
                                            }
                                        }
                                        if (s3 !== peg$FAILED) {
                                            s4 = peg$currPos;
                                            s5 = peg$currPos;
                                            s6 = peg$parseHEXDIG();
                                            if (s6 !== peg$FAILED) {
                                                s7 = peg$parseHEXDIG();
                                                if (s7 !== peg$FAILED) {
                                                    s8 = peg$parseHEXDIG();
                                                    if (s8 !== peg$FAILED) {
                                                        s9 = peg$parseHEXDIG();
                                                        if (s9 !== peg$FAILED) {
                                                            s6 = [s6, s7, s8, s9];
                                                            s5 = s6;
                                                        } else {
                                                            peg$currPos = s5;
                                                            s5 = peg$FAILED;
                                                        }
                                                    } else {
                                                        peg$currPos = s5;
                                                        s5 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s5;
                                                    s5 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s5;
                                                s5 = peg$FAILED;
                                            }
                                            if (s5 !== peg$FAILED) {
                                                s4 = input.substring(s4, peg$currPos);
                                            } else {
                                                s4 = s5;
                                            }
                                            if (s4 !== peg$FAILED) {
                                                peg$savedPos = s2;
                                                s2 = peg$f23(s4);
                                            } else {
                                                peg$currPos = s2;
                                                s2 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s2;
                                            s2 = peg$FAILED;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f24(s2);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }

        return s0;
    }

    function peg$parseescape() {
        let s0;

        if (input.charCodeAt(peg$currPos) === 92) {
            s0 = peg$c23;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e33);
            }
        }

        return s0;
    }

    function peg$parsequotation_mark() {
        let s0;

        if (input.charCodeAt(peg$currPos) === 34) {
            s0 = peg$c24;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e34);
            }
        }

        return s0;
    }

    function peg$parseunescaped() {
        let s0;

        s0 = input.charAt(peg$currPos);
        if (peg$r8.test(s0)) {
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e35);
            }
        }

        return s0;
    }

    function peg$parseDIGIT() {
        let s0;

        s0 = input.charAt(peg$currPos);
        if (peg$r2.test(s0)) {
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e7);
            }
        }

        return s0;
    }

    function peg$parseHEXDIG() {
        let s0;

        s0 = input.charAt(peg$currPos);
        if (peg$r9.test(s0)) {
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e36);
            }
        }

        return s0;
    }

    peg$result = peg$startRuleFunction();

    const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
    function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail(peg$endExpectation());
        }

        throw peg$buildStructuredError(
            peg$maxFailExpected,
            peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
            peg$maxFailPos < input.length
                ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
                : peg$computeLocation(peg$maxFailPos, peg$maxFailPos),
        );
    }
    if (options.peg$library) {
        return /** @type {any} */ ({
            peg$result,
            peg$currPos,
            peg$FAILED,
            peg$maxFailExpected,
            peg$maxFailPos,
            peg$success,
            peg$throw: peg$success ? undefined : peg$throw,
        });
    }
    if (peg$success) {
        return peg$result;
    } else {
        peg$throw();
    }
}

const peg$allowedStartRules = ["batch"];

export { peg$allowedStartRules as StartRules, peg$SyntaxError as SyntaxError, peg$parse as parse };
